
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import PageRequest from '@/store/entities/page-request';
    import ApexCharts from 'apexcharts'
    import VueApexCharts from 'vue-apexcharts'
    import TableStats from './tables.vue'
    import ThermometerStats from './thermometer.vue'
    import EvolutionStats from './evolution.vue'
    import CalificationStats from './calification.vue'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget, TableStats, ThermometerStats, EvolutionStats, CalificationStats },
    })

    export default class ChartOperation extends ListBase {
        @Prop({ type: PageRequest, default: () => { return new PageRequest() } }) pagerequest: PageRequest;

        async loadData() {
            await this.$store.dispatch({
                type: 'quiz/getTableStats',
                data: this.pagerequest
            });
        }

        async mounted() {
            await this.loadData();
        }
    }
